import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { authData } from "src/app/util/auth";
import { errorHandler } from "src/app/util/errorHandler";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-slot-reservation-index",
  templateUrl: "./slot-reservation-index.component.html",
})
export class SlotReservationIndexComponent implements OnInit, OnDestroy {
  constructor(private httpClient: HttpClient, private router: Router) {}

  info: any = null;
  notification = {};
  refreshing = true;
  reserving = false;
  countdown = "";
  private timer: any = null;

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + authData().Token,
    }),
  };

  ngOnInit(): void {
    this.loadInfo();
  }

  ngOnDestroy(): void {
    if (this.timer) clearInterval(this.timer);
  }

  loadInfo(): void {
    this.refreshing = true;
    const baseUrl = `${environment.BASE_URL}/slotreservation/slotReservationInfo`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe({
      next: (res: any) => {
        this.refreshing = false;
        if (res.Success) {
          this.info = res.Data;
          this.startCountdown();
        } else {
          this.notification = errorHandler(res);
        }
      },
      error: (err: any) => {
        this.refreshing = false;
        this.notification = errorHandler(err);
      },
    });
  }

  reserveSlot(): void {
    this.reserving = true;
    this.notification = {};
    const baseUrl = `${environment.BASE_URL}/slotreservation/reserveSlot`;
    this.httpClient.post(baseUrl, {}, this.httpOptions).subscribe({
      next: (res: any) => {
        this.reserving = false;
        if (res.Success) {
          this.info = res.Data;
          this.notification = { error: false, message: res.Message };
          this.startCountdown();
        } else {
          this.notification = { error: true, message: res.Message };
        }
      },
      error: (err: any) => {
        this.reserving = false;
        this.notification = errorHandler(err);
      },
    });
  }

  goToPayments(): void {
    this.router.navigate(["/payments"]);
  }

  private startCountdown(): void {
    if (this.timer) clearInterval(this.timer);
    if (!this.info || this.info.Status !== "Pending" || !this.info.ReservationEndTime)
      return;

    const end = +new Date(this.info.ReservationEndTime);
    const tick = () => {
      const diff = end - +new Date();
      if (diff <= 0) {
        this.countdown = "Expired";
        clearInterval(this.timer);
        this.loadInfo();
        return;
      }
      const hrs = Math.floor(diff / 3.6e6);
      const mins = Math.floor((diff % 3.6e6) / 6e4);
      const secs = Math.floor((diff % 6e4) / 1000);
      this.countdown = `${hrs}h ${mins}m ${secs}s`;
    };
    tick();
    this.timer = setInterval(tick, 1000);
  }
}
